import { Checkbox, FormControlLabel } from '@mui/material'
import React, { useState } from 'react'
import InputField from '../CommonComponents/InputMUI'

import Alerts from './SidePopup'

const DeletePopup = ({ handler }) => {
    const [data, setData] = useState({
        id: '', loanId: '', linkId: '', url: '', expiryTime: '',
        createdAt: '', dataMask: '', documentVisible: '', activityVisible: '', name: ''
    })
    const [message, setMessage] = useState({})
    const [alertPopup, setAlertPopup] = useState(false)
    const [msg, setMsg] = useState('')

    const removePopup = () => {
        setTimeout(
            function () {
                setAlertPopup(false)
            }.bind(this),
            5000
        );
    }
    const handleChechbox = (e, type) => {
        let changeObjectData = Object.assign({}, data)
        changeObjectData[type] = e.target.checked;
        setData(changeObjectData)
        setMessage({})
    }
    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, data)
        changeObjectData[type] = e;
        setData(changeObjectData)
        setMessage({})
    }

    const save = () => {
        const res = handler(data, "save")
        if (res === 'success') {
            setAlertPopup(true)
            removePopup()
        } else {
            setMsg(res)
            setAlertPopup(true)
            removePopup()
        }
    }

    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main'>
                <h2 className='mb-3'>Create Custom Link</h2>
                <hr />
                
                <div className='mt-3 row'>
                    <div className='mb-3 col-sm-6' style={{marginTop:'-10px'}}>
                        <InputField
                            label="Name"
                            variant="outlined"
                            value={data.name}
                            name="name"
                            id="name"
                            type="text"
                            onChange={e => inputChange(e, "name")}
                            size="small" />
                      
                    </div>
                    <div className='mb-3 col-sm-6'>
                        <FormControlLabel
                            label="Data Masked"
                            control={<Checkbox checked={data.dataMask} onChange={e => handleChechbox(e, "dataMask")} />}
                        />
                    </div>

                    <div className='mb-3 col-sm-6'>
                        <FormControlLabel
                            label="Show Document"
                            control={<Checkbox checked={data.documentVisible} onChange={e => handleChechbox(e, "documentVisible")} />}
                        />
                    </div>
                    <div className='mb-3 col-sm-6'>
                        <FormControlLabel
                            label="Show Activity"
                            control={<Checkbox checked={data.activityVisible} onChange={e => handleChechbox(e, "activityVisible")} />}
                        />
                    </div>
                </div>
                <div className="text-center">
                    <button type="button" className="cred-btn" onClick={e => handler("", "close")}>Close</button>
                    <button type="button" className="cred-btn" onClick={e => save('save')}>Generate</button>
                </div>
            </div>
            {alertPopup ?
                <Alerts msg={msg} />
                : ""}
        </div>
    )
}

export default DeletePopup;